const indexItems = [
  { label: '国产剧', icon: 'ri-tv-line', count: '1280部', color: 'text-primary-500', bg: 'bg-primary-50' },
  { label: '韩剧', icon: 'ri-heart-line', count: '860部', color: 'text-accent-500', bg: 'bg-accent-50' },
  { label: '美剧', icon: 'ri-global-line', count: '720部', color: 'text-primary-500', bg: 'bg-primary-50' },
  { label: '日剧', icon: 'ri-sun-line', count: '460部', color: 'text-accent-500', bg: 'bg-accent-50' },
  { label: '电影', icon: 'ri-film-line', count: '3200部', color: 'text-primary-500', bg: 'bg-primary-50' },
  { label: '综艺', icon: 'ri-emotion-laugh-line', count: '950部', color: 'text-accent-500', bg: 'bg-accent-50' },
  { label: '动漫', icon: 'ri-rocket-line', count: '1800部', color: 'text-primary-500', bg: 'bg-primary-50' },
  { label: '纪录片', icon: 'ri-earth-line', count: '620部', color: 'text-accent-500', bg: 'bg-accent-50' },
  { label: '短剧', icon: 'ri-flashlight-line', count: '350部', color: 'text-primary-500', bg: 'bg-primary-50' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            分类索引
          </h2>
          <p className="text-sm text-foreground-500">快速找到你想看的影视类型</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="flex flex-col items-center gap-2 p-5 bg-background-100 rounded-lg border border-background-200 hover:border-primary-200 transition-all hover:-translate-y-1 cursor-pointer"
            >
              <div className={`w-11 h-11 flex items-center justify-center rounded-full ${item.bg}`}>
                <i className={`${item.icon} ${item.color} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{item.label}</span>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}